<template>
    <div>
      <!-- <div v-show="loading" class="loading_show"><div class="spinner-border text-danger"></div></div> -->
      <table-component v-bind:data="fetchAccountData" :show-caption="false" :show-filter="false" :cache-key="2" cache-lifetime="0" ref="table2"  :filter-no-results=no_result>
          <table-column show="companyName" :sortable="true" label="ACCOUNT NAME">
            <template slot-scope="row">
              {{ row.companyName }}
            </template>
          </table-column>
          <table-column :sortable="false" label="SCHOOL">
              <template slot-scope="row">
              <i class="fa fa-check custom-tick" v-if="row.schoolFlag"></i>
              <i class="fa fa-times custom-remove" v-else></i>
              </template>
           </table-column>
          <table-column show="menteeCount" :sortable="false" label="MENTEE COUNT"></table-column>
          <table-column show="assessmentCount" :sortable="false" label="ASSESSMENT COUNT"></table-column>
      </table-component>
    </div>
</template>

<script>
import Vue from 'vue/dist/vue.esm';
import TableComponent2 from 'vue-table-component';
import axios from 'axios';
import store from '../../store/store.js';

TableComponent2.settings({
    tableClass: 'table-responsive table table-hover w-100',
    theadClass: '',
    tbodyClass: '',
    filterPlaceholder: 'Filter table…',
});

export default {
      data() {
        return {
          loading: true,
          no_result: 'Loading...'
        }
      },
      methods: {
        fetchAccountData({ page, filter, sort }) {
            return new Promise(resolve => {
                axios.get('/accounts', { headers: { 'Access-Control-Allow-Origin': '*', 'Accept': 'application/json', 'Content-Type': 'application/json' }, params: {  _sort: sort, _page: page } })
                .then(response => resolve({
                    data: response.data.data,
                    pagination: {
                        totalPages: response.data.total_pages,
                        currentPage: response.data.page,
                        count: response.data.total_rows
                    },
                })
                );
            })
        },
      },
      beforeCreate() {
          if((this.$store.state.page_url) && (this.$store.state.page_url === 'AccountUserLists')) {
            this.$store.dispatch('active_tab', '');
          }
      }
    }
</script>



// WEBPACK FOOTER //
// src/components/admin/accountlists.vue